import { AppCard, AppCardBody, AppText, kindredFontFamilies } from "../../ui-foundation";
import {
  DocumentList,
  DocumentPageScaffold,
  DocumentSection,
} from "@/components/DocumentScaffold";
import {
  KINDRED_FRENCH_PRIVACY_PATH,
  KINDRED_SUPPORT_EMAIL,
  STEADY_HOUSE_LEGAL_NAME,
  STEADY_HOUSE_SUPPORT_URL,
} from "../../shared/support";

const TermsFrench = () => {
  return (
    <DocumentPageScaffold
      title="Conditions d'utilisation"
      updatedLabel="Dernière mise à jour : avril 2026"
      fallbackPath="/"
      footerLinks={[
        { href: "/terms", label: "English terms" },
        { href: KINDRED_FRENCH_PRIVACY_PATH, label: "Politique de confidentialité" },
        { href: "/contact-complaints", label: "Contact & complaints" },
      ]}
    >
      <DocumentSection title="1. Portée">
        <AppText>
          Ces conditions résument les principales règles qui s&apos;appliquent lorsque vous utilisez
          Kindred Community. Le lancement du Canada est actuellement en pause pendant que Kindred prépare
          une couche publique, juridique et d&apos;assistance correcte pour le Québec et le français.
        </AppText>
        <AppText>
          Cette version française reste disponible à titre de référence uniquement et ne signifie pas que le
          Canada est un marché actif ou imminent.
        </AppText>
      </DocumentSection>

      <DocumentSection title="2. Conditions de base">
        <DocumentList
          items={[
            "Vous devez avoir au moins 18 ans pour utiliser Kindred.",
            "Kindred est un service communautaire pour parents solos. Ce n'est ni un service juridique, ni un service médical, ni un service d'urgence.",
            "Vous devez fournir des informations exactes, protéger votre mot de passe et signaler tout accès non autorisé à votre compte.",
            "Vous restez responsable du contenu et des activités publiés depuis votre compte.",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="3. Contenu et conduite">
        <DocumentList
          items={[
            "Le harcèlement, l'intimidation, les avances sexuelles, la fraude, l'usurpation d'identité et le contenu illégal sont interdits.",
            "Vous ne pouvez publier que du contenu que vous avez le droit de partager.",
            "Si un enfant est identifiable dans un contenu, vous devez avoir le droit ou l'autorisation nécessaire pour le publier.",
            "Kindred peut supprimer un contenu, restreindre un compte, suspendre un membre ou fermer un compte pour des raisons de sécurité, de confidentialité, de modération ou de conformité légale.",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="4. Confidentialit et services tiers">
        <AppText>
          L&apos;utilisation des données personnelles est expliquée dans la politique de confidentialité
          française disponible sur <strong>{KINDRED_FRENCH_PRIVACY_PATH}</strong>.
        </AppText>
        <DocumentList
          items={[
            "Kindred n'achète ni ne vend des données personnelles.",
            "Kindred n'utilise pas les données personnelles des membres pour les partager avec des tiers pour leur propre publicité ou marketing.",
            "Kindred utilise des prestataires pour exploiter le service, y compris Supabase, Resend et n8n lorsque cela est nécessaire au fonctionnement du service.",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="5. Droit applicable et contact">
        <AppText>
          Les présentes conditions sont régies par les lois d&apos;Angleterre et du pays de Galles, sous
          réserve des protections impératives de votre pays ou province de résidence lorsqu&apos;elles
          s&apos;appliquent.
        </AppText>
        <AppText>
          Pour toute question, plainte, demande de révision de modération ou demande formelle, utilisez{" "}
          <a
            href={STEADY_HOUSE_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="kindred-inline-link"
          >
            la page d&apos;assistance Steady House
          </a>{" "}
          ou écrivez{" "}
          <a href={`mailto:${KINDRED_SUPPORT_EMAIL}`} className="kindred-inline-link">
            {KINDRED_SUPPORT_EMAIL}
          </a>
          .
        </AppText>
      </DocumentSection>

      <AppCard backgroundColor="$panelBackground">
        <AppCardBody alignItems="center">
          <AppText
            textAlign="center"
            fontFamily={kindredFontFamilies.sansBold}
            fontSize="$md"
            lineHeight="$md"
          >
            {STEADY_HOUSE_LEGAL_NAME} exploite Kindred Community. Cette version française reste une
            référence de travail pendant que le lancement du Canada est en pause.
          </AppText>
        </AppCardBody>
      </AppCard>
    </DocumentPageScaffold>
  );
};

export default TermsFrench;
